<template>
  <div class="col-12 report-filter">
    <Field
      type="select"
      label="Filter Type"
      :name="`filter_type_${index}`"
      v-model="filter.type"
      :options="types"
      :hideSelectEmptyOption="true"
    />
    <Field
      type="select"
      label="Filter"
      :name="`settings[filters][${index}][slug]`"
      v-model="filter.slug"
      :options="slugOptions"
      :hideSelectEmptyOption="true"
    />
    <Field
      v-if="filter.slug"
      type="select"
      label="Condition"
      :name="`settings[filters][${index}][operand]`"
      v-model="filter.operand"
      :options="operandOptions"
      :hideSelectEmptyOption="true"
    />
    <Field
      v-if="operandType == 'date'"
      type="select"
      label="Date Option"
      :name="`settings[filters][${index}][date_option]`"
      v-model="filter.date_option"
      :options="dateOptions"
      :hideSelectEmptyOption="true"
    />
    <Field
      v-if="valueFieldType == 'text'"
      type="text"
      label="Value"
      :name="`settings[filters][${index}][value]`"
      v-model="filter.value"
    />
    <Field
      v-if="valueFieldType == 'date'"
      type="datepicker"
      label="Value"
      :name="`settings[filters][${index}][value]`"
      v-model="filter.value"
    />
    <Field
      v-if="valueFieldType == 'select'"
      type="select"
      label="Value"
      :name="`settings[filters][${index}][value]`"
      v-model="filter.value"
      :options="picklists[filter.slug] || []"
      :hideSelectEmptyOption="true"
    />
    <Field
      v-if="valueFieldType == 'toggle'"
      type="select"
      label="Value"
      :name="`settings[filters][${index}][value]`"
      v-model="filter.value"
      :options="toggleOptions"
      :hideSelectEmptyOption="true"
    />
    <div class="remove-filter">
      <a class="btn-sm btn-danger" href="#" @click.prevent="remove">Remove</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filters: { type: Object, required: true },
    types: { type: Array, required: true },
    operands: { type: Object, required: true },
    dateOptions: { type: Array, required: true },
    value: { type: Object, required: true },
    index: { type: Number, required: true },
    picklists: { type: Object, default: () => {} },
  },
  data() {
    return {
      filter: {
        type: null,
        slug: null,
        operand: "=",
        date_option: "custom",
        value: "",
      },
      toggleOptions: [
        { label: "Yes", value: 1 },
        { label: "No", value: 0 },
      ],
    };
  },
  computed: {
    slugOptions() {
      if (!this.filter.type) return [];
      var filters = this.filters[this.filter.type];
      return Object.keys(filters)
        .map((slug) => {
          var attrs = filters[slug];
          return { label: attrs.label, value: slug };
        })
        .sort((a, b) => {
          if (a.label == b.label) {
            return 0;
          }
          return a.label < b.label ? -1 : 1;
        });
    },
    operandType() {
      if (!this.filter.type || !this.filter.slug) return null;
      return this.filters[this.filter.type][this.filter.slug].type;
    },
    operandOptions() {
      if (!this.filter.type || !this.filter.slug || !this.operandType)
        return [];
      return this.operands[this.operandType];
    },
    valueFieldType() {
      if (!this.filter.type || !this.filter.slug || !this.operandType)
        return null;
      if (this.operandType == "date") {
        if (_.startsWith(this.filter.date_option, "current_")) {
          return null;
        } else if (this.filter.date_option == "custom") {
          return "date";
        } else {
          return "text";
        }
      } else if (this.operandType == "toggle") {
        return "toggle";
      } else if (this.operandType == "picklist") {
        return "select";
      } else {
        return "text";
      }
    },
  },
  watch: {
    value(val) {
      if (!_.isEmpty(this.value)) {
        this.filter = _.cloneDeep(this.value);
      }
    },
    "filter.slug": function (val) {
      this.$emit("slug-changed", this.filter.slug, this.filter.type);
    },
    "filter.value": function (val) {
      if (this.valueFieldType == "date") {
        this.filter.value = this.$moment(val).format("YYYY-MM-DD 00:00:00");
      }
    },
  },
  methods: {
    remove() {
      this.$emit("remove", this.index);
    },
  },
  created() {
    if (!_.isEmpty(this.value)) {
      this.filter = _.cloneDeep(this.value);
    }
  },
};
</script>